<nav *ngIf="isLogged" class="navbar navbar-expand-lg navbar-dark bg-dark">
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarNav"
    aria-controls="navbarNav"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon" (click)="clickToggleMenu()"></span>
  </button>
  <div class="collapse navbar-collapse show" id="navbarNav">
    <button
      *ngIf="!isLogged"
      class="btn btn-outline-success my-sm-0"
      routerLink="/login"
      type="submit"
    >
      <em class="fas fa-sign-in-alt"></em>
      <label class="textButton"> Iniciar Sesión</label>
    </button>
    <button
      *ngIf="isLogged"
      class="btn btn-outline-danger my-sm-0"
      (click)="onLogOut()"
      type="button"
    >
      <em class="fas fa-sign-in-alt"></em>
      <em class="fas fa-door-open hide"></em>
      <label class="textButton"> Cerrar Sesión </label>
    </button>

    <div *ngIf="navBarUserData" class="userDataDiv">
      <div>
        {{ navBarUserData?.nombre }}&nbsp;{{ navBarUserData?.apellido1 }}
      </div>
      <div>{{ descripcionDelPerfil(navBarUserData.perfiles[0]) }}</div>
      <div>
        Último acceso: {{ navBarUserData?.lastLoginDate | date : "dd/MM/yyyy" }}
      </div>
    </div>

    <div class="rightImagesContainer">
      <div class="imgLogoContainer">
        <img
          class="imgLogo"
          src="./../../../assets/images/login/Triton-InternaAlt.png"
          alt="Titron interno"
        />
      </div>
      <div class="imgLogoContainer">
        <img
          class="imgLogo hide"
          src="./../../../assets/images/login/LogoTritonNoText2.png"
          alt="Logo triton"
        />
      </div>
    </div>
  </div>

  <div
    id="sideMenu"
    [ngClass]="{
      showElementSideMenu: displayMenuUnFolded,
      hideElementSideMenu: !displayMenuUnFolded
    }"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  >
    <div *ngIf="displayMenuUnFolded" class="unfoldedMenu">
      <ul
        id="menuFor"
        *ngFor="let menuElement of menuPrincipal"
        [ngStyle]="{
          display: checkPermission(menuElement.profiles) ? 'block' : 'none'
        }"
      >
        <li
          [ngClass]="{
            showSubMenu: menuElement.subMenuStatus,
            hideSubMenu: !menuElement.subMenuStatus
          }"
          *ngIf="checkPermission(menuElement.profiles) == true"
        >
          <span
            class="menuTitle"
            (click)="clickToggleSideSubMenu(menuElement.id)"
          >
            <em
              [ngClass]="{
                openIco: menuElement.subMenuStatus,
                closeIco: !menuElement.subMenuStatus
              }"
            ></em
            >&nbsp; <em class="{{ menuElement.icon }}"></em>&nbsp;<strong
              >{{ menuElement.nombreCompleto }}
            </strong>
          </span>
          <ng-container *ngIf="menuElement.url" class="childList">
            <a routerLink="{{ menuElement?.url }}"
              ><em class="{{ menuElement.icon }}"></em>&nbsp;{{
                menuElement.id
              }}</a
            >
          </ng-container>
          <div *ngIf="menuElement?.subMenu?.length > 0">
            <ul
              id="subMenuFor"
              class="subMenuFor"
              *ngFor="let subMenu of menuElement.subMenu"
              [ngStyle]="{
                display: checkPermission(subMenu.profiles) ? 'block' : 'none'
              }"
            >
              <li *ngIf="checkPermission(subMenu.profiles) == true">
                <a
                  (click)="goList(subMenu.url)"
                  [ngClass]="{
                    disabledMenuLink: !subMenu?.url,
                    enabledMenuLink: subMenu?.url
                  }"
                >
                  <em class="{{ subMenu.icon }}"></em>&nbsp; {{ subMenu.id }}</a
                >
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <span class="versionSize">v{{ version }}</span>
    </div>
    <div *ngIf="!displayMenuUnFolded" class="foldedMenu">
      <ul
        id="menuFor"
        *ngFor="let menuElement of menuPrincipal"
        [ngStyle]="{
          display: checkPermission(menuElement.profiles) ? 'block' : 'none'
        }"
      >
        <li
          [ngClass]="{
            showSubMenu: menuElement.subMenuStatus,
            hideSubMenu: !menuElement.subMenuStatus
          }"
          *ngIf="checkPermission(menuElement.profiles)"
        >
          <span
            class="menuTitle"
            (click)="clickToggleSideSubMenu(menuElement.id)"
          >
            <em
              class="svgSubMenuIconArrows"
              [ngClass]="{
                openIco: menuElement.subMenuStatus,
                closeIco: !menuElement.subMenuStatus
              }"
            ></em
            >&nbsp;
            <em
              title="{{ menuElement.nombreCompleto }}"
              class="svgMenuIcon {{ menuElement.icon }}"
            ></em>
          </span>
          <ng-container *ngIf="menuElement.url" class="childList">
            <a routerLink="{{ menuElement?.url }}"
              ><em class="{{ menuElement.icon }}"></em>&nbsp;{{
                menuElement.id
              }}</a
            >
          </ng-container>
          <div *ngIf="menuElement?.subMenu?.length > 0">
            <ul
              id="subMenuFor"
              class="subMenuFor"
              *ngFor="let subMenu of menuElement.subMenu"
              [ngStyle]="{
                display: checkPermission(subMenu.profiles) ? 'block' : 'none'
              }"
            >
              <li *ngIf="checkPermission(subMenu.profiles) == true">
                <a
                  (click)="goList(subMenu.url)"
                  [ngClass]="{
                    disabledMenuLink: !subMenu?.url,
                    enabledMenuLink: subMenu?.url
                  }"
                >
                  <em
                    title="{{ subMenu.id }}"
                    class="svgSubMenuIcon {{ subMenu.icon }}"
                  ></em>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <span class="versionSize">v{{ version }}</span>
    </div>
  </div>
</nav>
